import React from "react";
import classnames from "classnames";

export const BUTTON_STATES = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  DISABLED: "DISABLED",
  COMPLETE_SUCCESS: "COMPLETE_SUCCESS",
  COMPLETE_ERROR: "COMPLETE_ERROR"
};

export const ButtonContainer = ({ children, vertical, horizontal, ...rest }) => {
  return (
    <div
      className={classnames("btn-container", {
        "btn-container-vertical": vertical,
        "btn-container-horizontal": horizontal || !vertical
      })}
      {...rest}
    >
      {children}
    </div>
  );
};

export const Button = ({
                         label,
                         children,
                         onClick = () => {},
                         href,
                         small,
                         secondary,
                         inverted,
                         rounded,
                         loading,
                         disabled,
                         className,
                         collapsible,
                         title,
                         ...other
                       }) => {
  return (
    <button
      className={classnames("btn", {
        "btn-primary": !secondary,
        "btn-secondary": secondary,
        "btn-disabled": disabled,
        "btn-loading": loading,
        "btn-rounded": rounded,
        "btn-small": small,
        "btn-inverted": inverted,
        "btn-collapsible": collapsible,
      }, className)}
      title={title || label || children}
      disabled={disabled}
      onClick={
        href
          ? () => {
            window.location.href = href;
          }
          : onClick
      }
      {...other}
    >
      <div className="btn-label">{label || children}</div>
      {loading && (
        <div className="btn-spinner-container">
          <div className="btn-spinner" />
        </div>
      )}
    </button>
  );
};


export default Button;
